export default function useKeyCounter() {
  let counter = 0
  return {
    getKey: () => {
      counter += 1
      return counter
    },
  }
}
